import { Injectable } from '@angular/core';
import { messageCursoResponseInterface } from '../../interfaces/curso/curso-response.interface';


@Injectable({
  providedIn: 'root'
})
export class ParamCursoDataService {

  data!: messageCursoResponseInterface;
  nome_curso: string = '';
  forma_pagamento_selecionada: string = '';

  private moroNoBrasil: boolean = false;
  private url_boleto: string = '';
  private qtde_Vagas: string = '';
  private cusro_cancelado: boolean = false;
  private gratuito: boolean = false;
  private taxa_inscricao: string = '';
  private curso_fechado: boolean = true;
  private valor_pago_pela_empresa: number = 0;

  fluxo_continuo: boolean = false;
  sigla: string = '';
  oferecimento: string = '';

  set valorPagoPelaEmpresa(val: string){
    this.valor_pago_pela_empresa = parseFloat(val);
  }

  get empresaIraPagar(): boolean{
    return this.valor_pago_pela_empresa > 0;
  }

  set cursoFechado(cf: string){

    this.curso_fechado = cf === 'NÃO' ? false : true;
  }

  get cursoFechado(): boolean{
    return this.curso_fechado;
  }

  set taxaInscricao(taxa_inscricao: string){
    this.taxa_inscricao = taxa_inscricao;
  }

  get taxaInscricao(): string{
    return this.taxa_inscricao;
  }

  get curso_sem_taxa(): boolean{

    if(this.taxaInscricao == '0' || this.taxaInscricao === '' || this.taxaInscricao == undefined){

      return true;
    }

    try{

      let taxa = parseFloat(this.taxa_inscricao);

      if( taxa <= 0){

        return true;
      }else{

        return false;
      }
    }catch(error: any){

      return false;
    }
  }

  get cursoGratuito(): boolean{
    return this.gratuito;
  }

  set cursoGratuito(gratuito: boolean){
    this.gratuito = gratuito;
  }

  get cusroCancelado(): boolean{
    return this.cusro_cancelado;
  }

  set cusroCancelado(cusro_cancelado: boolean){
    this.cusro_cancelado = cusro_cancelado;
  }

  set qtdeVagas(qtdeVagas: string){
    this.qtde_Vagas = qtdeVagas;
  }

  get qtdeVagas(): string{
    return this.qtde_Vagas;
  }

  set NomeCurso(nome_curso: string){
    this.nome_curso = nome_curso;
  }

  get NomeCurso(): string{
    return this.nome_curso;
  }

  set urlBoleto(url_boleto: string){
    this.url_boleto = url_boleto;
  }

  get urlBoleto(): string{
    return this.url_boleto;
  }


  setMoroNoBrasil(moro_no_brasil: boolean){
    this.moroNoBrasil = moro_no_brasil;
  }

  getMoroNoBrasil(): boolean{
    return this.moroNoBrasil;
  }

  setDataSubmit(data: messageCursoResponseInterface){

    this.data = data;
  }

  getDataSubmit(): messageCursoResponseInterface{

    return this.data;
  }

}
